export const electronConstants = {
  LOG_OUT_STEAM: "LOG_OUT_STEAM",
  RELOAD_PROFILE: "RELOAD_PROFILE",
  RELOAD_PROTOCOL_LINK: "freegame://reload-user",
};
